import React from "react";
import PropTypes from "prop-types";
import ReturnIcon from "../SVGComponents/ReturnIcon";

const ReturnButton = ({ showOverlay }) => (
  <button
    data-quid="return-button"
    className="sub-navigation__item sub-navigation__item--return"
    onClick={() => showOverlay("return")}
  >
    <ReturnIcon />
    dominos.com
  </button>
);

ReturnButton.propTypes = {
  showOverlay: PropTypes.func.isRequired
};

export default ReturnButton;
